<template>
	<div :style ="'margin-top : '+height/2+'px'" class="text-center">
		<h1> Vous allez être redirigé vers le site Adhérent d’ici quelques secondes.</h1>
	</div>
</template>

<script>
 
   	import api from "../config/_api";
   
    import {AUTH_LOGOUT} from '../store/actions/auth';
 export default {
        name: "redirect",
		data (){
			return {
				width: 0,
                height: 0,
				email:"",
				token:"",
				struct_id:0,
				role:0,
			}
		},
		created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
		},
		mounted(){
			this.$data.email = this.$route.params.email;
			this.$data.token = this.$route.params.token;
			this.$data.struct_id = this.$route.params.struct_id;
			this.$data.role = this.$route.params.role;
			
			setTimeout(function(){
					this.$store.dispatch(AUTH_LOGOUT).then( function(){
						if(this.$data.email != '' && this.$data.token != ''){
							if(this.$data.struct_id != 0 && this.$data.role != 0){
								window.location=api.siteAdherent+"login/"+this.$data.token+"/"+this.$data.email+"/"+this.$data.struct_id+"/"+this.$data.role;
							}
							else{
								window.location=api.siteAdherent+"login/"+this.$data.token+"/"+this.$data.email;
							}
						}
						else{
							window.location=api.siteAdherent;
						}
					}.bind(this));
				
			}.bind(this), 1000);
		},
		
        methods: {
            handleResize() {
                this.width = window.innerWidth;
                this.height = window.innerHeight-20;
            },
		}
 }

</script>

<style>
</style>